module.exports = " <div class=ad> <img class=ad__image :src=image> <div class=ad__content> <h1 class=ad-title>{{getResource('AdvertisementHeader')}}</h1> <p class=ad-leading>{{getResource('AdvertisementContent')}}</p> <a href=# class=simple-button v-on:click.prevent=navigateToKiosk()>{{getResource('GetItNow')}}</a> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/views/home/HomeNewsAd.vue
// module id = 192
// module chunks = 0